<template>
	<div class="content-safe-space">
		<div class="width-limited">
			<loader v-if="!form.isReady()"/>
			<component :is="component" v-else ref="form" :form="form" :processing="form.processing" @submit="submit"/>
			<!--			<ConveyancingQuoteForm-->
			<!--				v-else ref="form" :form="form" :processing="form.processing" @submit="submit"/>-->
		</div>
	</div>
</template>
<script>
import {mapMutations, mapState} from "vuex";
import conveyancingFormFields from "../../../constants/conveyancingFormFields";
import sdltFormFields from "../../../constants/sdltFormFields";
import ConveyancingQuoteForm from "../components/ConveyancingQuoteForm.vue";
import LandTaxCalculationQuoteForm from "../components/LandTaxCalculationQuoteForm.vue";

export default {
	components: {
		ConveyancingQuoteForm,
		LandTaxCalculationQuoteForm,
	},

	data() {
		return {
			form: this.newForm({
				data: {
					conveyancing: conveyancingFormFields,
					landTaxCalculation: sdltFormFields,
				},
			}),
		};
	},

	computed: {
		...mapState("quote", [
			"quote",
		]),
		component() {
			return this.$route.params.service + "QuoteForm";
		},
	},

	methods: {
		...mapMutations("quote", [
			"setQuote",
		]),
		submit() {
			this.form.post(this.route("/quotes/services/:service", this.$route.params)).then(response => {
				this.setQuote(response.data);

				this.tellParentToReport("quoteFormSubmitted", {
					quote: this.quote.id,
				});

				this.tellParentToCall("handleResult", {
					id: this.quote.id,
				});

				let params = this.$route.params;
				params["quote"] = this.quote.id;
				this.$router.push({name: "quotes.show", params: params});
			});
		},
	},

	created() {
		this.form.prepare((form) => {
			http().get(this.route("/quotes/create", this.$route.params)).then(response => {
				form
					.setOptions(response.data)
					.onChangeOnce(({diffs}) => {
						this.trackEvent("quoteFormStarted", diffs);
					})
					.on422(() => {
						this.tellParentToScrollToIFrame();
					})
					.ready();
			});
		});
	},
};
</script>
